import { createContext, useContext, useEffect, useRef } from 'react';

export const FAVORITE_TAB_PARAM = 'favoriteTab';

export const FavoriteTabContext = createContext<{
  navigationKey: string;
  requested: string | null;
  report: (tab: string, label: string) => void;
} | null>(null);

/** Register a page's primary tabs. Drawer and table tabs deliberately stay local. */
export function useFavoriteTab<T extends string>(
  active: T,
  select: (tab: T) => void,
  available: readonly string[],
  ready = true,
  label = active.replace(/-/g, ' '),
) {
  const context = useContext(FavoriteTabContext);
  const restored = useRef<string | null>(null);
  useEffect(() => {
    if (!context || !ready) return;
    if (restored.current !== context.navigationKey) {
      restored.current = context.navigationKey;
      if (context.requested && available.includes(context.requested) && context.requested !== active) {
        select(context.requested as T);
        return;
      }
    }
    context.report(active, label);
  }, [context, active, select, available, ready, label]);
}
